import { useDisclosure } from '@chakra-ui/react'
import { FieldMap, FieldMapValue, FieldTypes, SentFax, WithId } from '@hb/shared'
import { useCallback, useMemo } from 'react'
import { resendFax } from '../../hooks/backend/faxes'
import { ActionButton } from '../Buttons'
import { GenericEditModal } from '../DataView/GenericEditModal'

interface ResendFaxData extends FieldMapValue {
  faxToNumber: string
  quality: 'high' | 'very_high'
}

const resendFaxField: FieldMap = {
  name: 'Resend Fax',
  children: {
    faxToNumber: {
      type: FieldTypes.PHONE,
      placeholder: 'Fax to #',
    },
    quality: {
      type: FieldTypes.DROPDOWN,
      placeholder: 'Quality',
      optional: true,
      options: [
        { id: 'high', text: 'High' },
        { id: 'very_high', text: 'Very High' },
      ],
    },
  },
}

export const ReSendFax = ({ fax }: { fax: WithId<SentFax> }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const onSubmit = useCallback(
    async ({ faxToNumber, quality }: ResendFaxData) => {
      try {
        const res = await resendFax({ faxId: fax.id, faxToNumber, quality })
        const data = res.data as { error?: string; success?: boolean }
        if (data?.error) return { error: data.error }
        return { success: 'Fax resent successfully' }
      } catch (err: any) {
        return { error: err?.message || 'Error resending fax' }
      }
    },
    [fax.id],
  )

  // remove non-numeric characters
  const initData = useMemo(
    () => ({ faxToNumber: fax.to.replace(/[^0-9]/g, ''), quality: 'very_high' }) as ResendFaxData,
    [fax.to],
  )

  return (
    <>
      <ActionButton size="sm" onClick={onOpen}>
        Re-send
      </ActionButton>
      <GenericEditModal
        field={resendFaxField}
        data={initData}
        isOpen={isOpen}
        canSubmitClean
        onClose={onClose}
        onSubmit={onSubmit}
        submitText="Resend Fax"
      />
    </>
  )
}
